import React, { useMemo } from 'react';
import { SERVICES } from '../data/services';
import { cx } from '../utils/cx';
import styles from './TechMarquee.module.css';

function Chip({ s }) {
  return (
    <div className={styles.svc}>
      <span className={styles.si}>
        <svg viewBox="0 0 24 24" fill={s.n === 'Apple' ? 'currentColor' : s.c} aria-hidden="true">
          <path d={s.d} />
        </svg>
      </span>
      {s.n}
    </div>
  );
}

function Row({ services, reverse, duration }) {
  // content duplicated twice for a seamless -50% loop
  const list = [...services, ...services, ...services, ...services];
  return (
    <div className={cx(styles.mrow, reverse && styles.rev)} style={{ '--t': `${duration}s` }}>
      {list.map((s, i) => (
        <Chip key={i} s={s} />
      ))}
    </div>
  );
}

// Two infinite-scroll rows moving in opposite directions, pausing on
// hover, with an edge mask + blur fade.
export default function TechMarquee() {
  const { rowA, rowB } = useMemo(() => {
    const half = Math.ceil(SERVICES.length / 2);
    return {
      rowA: [...SERVICES.slice(0, half), ...SERVICES.slice(half)],
      rowB: [...SERVICES.slice(half), ...SERVICES.slice(0, half)].reverse(),
    };
  }, []);

  return (
    <div className={styles.stack} aria-label={SERVICES.map((s) => s.n).join(', ')}>
      <Row services={rowA} duration={70} />
      <Row services={rowB} reverse duration={80} />
    </div>
  );
}
